<template>
  <v-container>
    <v-card>
      <v-card-title>Xóa Log Babilala</v-card-title>

      <v-card-text>
        <v-text-field
            label="ProfileId"
            v-model.trim="profileId"
            outlined
            dense
        />

        <v-text-field
            label="LevelId (không bắt buộc)"
            v-model.trim="leveIdToDeletePartPoint"
            outlined
            dense
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="error" @click="confirmDelete">
          Xóa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import { message } from "@/shared/message";

export default {
  name: "DeleteLogBabi",

  data() {
    return {
      profileId: "",
      leveIdToDeletePartPoint : ""
    };
  },

  methods: {
    confirmDelete() {
      if (!this.profileId) {
        message.error("Vui lòng nhập ProfileId");
        return;
      }

      if (!confirm(`Bạn có chắc chắn muốn xóa log của ProfileId = ${this.profileId}?`)) {
        return;
      }

      this.deleteLog();
    },

    async deleteLog() {
      try {
        await axios.post(process.env.VUE_APP_API_URL + "/kidAccountClass/deleteLogBabi", {
          profileId: this.profileId,
          leveIdToDeletePartPoint: this.leveIdToDeletePartPoint
        });
        message.success("Xóa log thành công");
        this.profileId = "";
        this.leveIdToDeletePartPoint = "";
      } catch (e) {
        message.error("Xóa log thất bại");
      }
    }
  }
};
</script>
